"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = VacationsPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const ScrumboardApi_1 = __importDefault(require("../Scrumboard/ScrumboardApi"));
const useScrumboardEvents_1 = require("../Scrumboard/useScrumboardEvents");
const AbsenceModal_1 = __importDefault(require("./AbsenceModal"));
require("./Vacations.css");
const vacationViewUtils_1 = require("./vacationViewUtils");
/**
 * Strona Urlopy (Biuro → Urlopy) — następca arkusza "urlopy".
 * Widok roczny (timeline) albo miesięczny (siatka dni).
 *
 * Dane bierze z tras /scrumboard/* i ze wspólnego kanału zdarzeń scrumboardu:
 * urlopy wyszły ze scrumboardu jako WIDOK, backend został na miejscu.
 */
function VacationsPage({ title }) {
    const now = new Date();
    const [year, setYear] = (0, react_1.useState)(now.getFullYear());
    const [month0, setMonth0] = (0, react_1.useState)(now.getMonth());
    // Widok miesieczny na wejsciu - decyzja ownera 2026-09-02. Na co dzien patrzy sie
    // na biezacy miesiac; rok jest do przegladu, nie do pracy.
    const [viewMode, setViewMode] = (0, react_1.useState)("month");
    // Salda (urlop / opieka / za święta) domyślnie zwinięte — na co dzień liczy się
    // kalendarz, a nie liczniki; rozwinięte zjadają szerokość timeline'u.
    const [showBalances, setShowBalances] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [draft, setDraft] = (0, react_1.useState)(null);
    async function load() {
        try {
            setData(await ScrumboardApi_1.default.getVacations(year));
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setLoading(false);
        }
    }
    (0, react_1.useEffect)(() => {
        if (title)
            document.title = title;
    }, [title]);
    (0, react_1.useEffect)(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year]);
    (0, useScrumboardEvents_1.useScrumboardEvents)({ "absence-changed": load }, load);
    function openAdd(prefill) {
        setDraft(prefill ?? {});
    }
    function openEditFor(row, dateStr) {
        const absence = (0, vacationViewUtils_1.findAbsenceOn)(row.absences, dateStr);
        if (absence)
            setDraft({
                id: absence.id,
                personId: absence.personId,
                typeId: absence.typeId,
                dateFrom: absence.dateFrom,
                dateTo: absence.dateTo,
                // Godziny decydują, w którym trybie otworzy się okno.
                startTime: absence.startTime,
                endTime: absence.endTime,
                note: absence.note,
            });
        else if (!(0, vacationViewUtils_1.isWeekendYmd)(dateStr))
            openAdd({ personId: row.personId, dateFrom: dateStr, dateTo: dateStr });
    }
    async function handleSave(payload) {
        // Bez try/catch — ewentualny błąd (np. brak dni opieki) propaguje się do modala,
        // który go pokazuje i zostaje otwarty. Zamykamy dopiero po sukcesie.
        if (payload.id)
            await ScrumboardApi_1.default.updateAbsence(payload.id, {
                typeId: payload.typeId,
                dateFrom: payload.dateFrom,
                dateTo: payload.dateTo,
                startTime: payload.startTime,
                endTime: payload.endTime,
                note: payload.note,
            });
        else
            await ScrumboardApi_1.default.addAbsence(payload);
        setDraft(null);
        load();
    }
    async function handleDelete(id) {
        try {
            await ScrumboardApi_1.default.deleteAbsence(id);
            setDraft(null);
            load();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    async function saveLimit(personId, limitDays, carryoverDays, careDays, holidayDays) {
        try {
            await ScrumboardApi_1.default.setVacationLimit(personId, year, limitDays, carryoverDays, careDays, holidayDays);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    function updateLimitLocal(personId, field, value) {
        setData((prev) => prev
            ? {
                ...prev,
                rows: prev.rows.map((r) => r.personId === personId ? { ...r, [field]: value } : r),
            }
            : prev);
    }
    if (loading)
        return react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center min-vh-100" },
            react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null));
    if (error)
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error));
    if (!data)
        return null;
    const persons = data.rows.map((r) => ({
        personId: r.personId,
        personName: r.personName,
    }));
    return (react_1.default.createElement(react_bootstrap_1.Card, null,
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "vacations" },
            react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center gap-2 mb-3" },
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, { size: "sm" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => setYear(year - 1) }, "\u2039"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", disabled: true }, year),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => setYear(year + 1) }, "\u203A")),
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, { size: "sm" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: viewMode === "year" ? "primary" : "outline-primary", onClick: () => setViewMode("year") }, "Rok"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: viewMode === "month" ? "primary" : "outline-primary", onClick: () => setViewMode("month") }, "Miesi\u0105c")),
                viewMode === "month" && (react_1.default.createElement(react_bootstrap_1.ButtonGroup, { size: "sm" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => setMonth0((month0 + 11) % 12) }, "\u2039"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", disabled: true, className: "vacation-month-label" }, vacationViewUtils_1.MONTHS_PL_LONG[month0]),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => setMonth0((month0 + 1) % 12) }, "\u203A"))),
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "success", onClick: () => openAdd() }, "+ Dodaj urlop"),
                react_1.default.createElement("div", { className: "d-flex flex-wrap gap-2 ms-auto vacation-legend" }, data.types.map((t) => (react_1.default.createElement("span", { key: t.id, className: "vacation-legend-item" },
                    react_1.default.createElement("span", { className: "vacation-swatch", style: { background: t.color } }),
                    t.name))))),
            viewMode === "year" ? (react_1.default.createElement(YearView, { data: data, showBalances: showBalances, onToggleBalances: () => setShowBalances(!showBalances), onOpenEdit: openEditFor, onLimitChange: updateLimitLocal, onLimitSave: saveLimit })) : (react_1.default.createElement(MonthView, { data: data, year: year, month0: month0, showBalances: showBalances, onToggleBalances: () => setShowBalances(!showBalances), onOpenEdit: openEditFor, onLimitChange: updateLimitLocal, onLimitSave: saveLimit })),
            react_1.default.createElement(AbsenceModal_1.default, { show: !!draft, draft: draft, persons: persons, types: data.types, rows: data.rows, onSave: handleSave, onDelete: handleDelete, onClose: () => setDraft(null) }))));
}
/**
 * Zapis wymiaru urlopu. Endpoint przyjmuje KOMPLET pul (urlop + zaległy + opieka
 * + za święta) i nadpisuje wiersz, więc każde pole musi wysłać wszystkie cztery —
 * inaczej edycja jednej puli wyzerowałaby pozostałe.
 */
function saveAll(row, onLimitSave) {
    onLimitSave(row.personId, row.limitDays, row.carryoverDays, row.careDays, row.holidayDays);
}
/**
 * Etykiety trzech pul. Kolejność jest kontraktem — nagłówki i komórki widoku
 * zwiniętego renderują się z tej samej tablicy, więc liczby stoją pod opisami.
 */
const POOLS = [
    { key: "vacation", short: "Urlop" },
    { key: "care", short: "Opieka" },
    { key: "holiday", short: "Święta" },
];
/**
 * Saldo każdej puli w jednym miejscu: liczba pozostałych dni + opis do tooltipa.
 * Widok rozwinięty i zwinięty czytają stąd, żeby opisy nie rozjechały się z liczbami.
 */
function poolBalances(row) {
    // Salda bywają ułamkowe od czasu nieobecności godzinowych, więc każda liczba
    // idzie przez formatDays: przecinek zamiast kropki, bez końcowych zer.
    const vacation = row.limitDays + row.carryoverDays - row.usedDays;
    const care = row.careDays - row.careUsedDays;
    const holiday = row.holidayDays - row.holidayUsedDays;
    const d = vacationViewUtils_1.formatDays;
    return {
        vacation: {
            remaining: vacation,
            title: `Urlop wykorzystany: ${d(row.usedDays)}, pozostały: ${d(vacation)} (Obecny ${d(row.limitDays)} + Zaległy ${d(row.carryoverDays)} − wykorzystany ${d(row.usedDays)})`,
        },
        care: {
            remaining: care,
            title: `Opieka wykorzystana: ${d(row.careUsedDays)}, pozostała: ${d(care)} (pula ${d(row.careDays)} − wykorzystana ${d(row.careUsedDays)})`,
        },
        holiday: {
            remaining: holiday,
            title: `Wolne za święta wykorzystane: ${d(row.holidayUsedDays)}, pozostałe: ${d(holiday)} (pula ${d(row.holidayDays)} − wykorzystane ${d(row.holidayUsedDays)})`,
        },
    };
}
/** Liczba pozostałych dni — na minusie czerwona, w obu widokach tak samo. */
function RemainingValue({ balance, children, }) {
    return (react_1.default.createElement("span", { title: balance.title, className: balance.remaining < 0 ? "text-danger fw-semibold" : "fw-semibold" }, children ?? (0, vacationViewUtils_1.formatDays)(balance.remaining)));
}
/** Pole limitu: w trybie odczytu pokazuje wartość; klik → input (jak godziny w zadaniach). */
function LimitInput({ label, title, value, onChange, onBlur, }) {
    const [editing, setEditing] = (0, react_1.useState)(false);
    const originalRef = (0, react_1.useRef)(value);
    return (react_1.default.createElement("label", { className: "vacation-limit-field", title: title },
        react_1.default.createElement("span", { className: "text-muted" }, label),
        editing ? (react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: 0, step: 1, size: "sm", autoFocus: true, className: "vacation-limit-input", value: value, onChange: (e) => onChange(Number(e.target.value)), onBlur: () => {
                setEditing(false);
                onBlur();
            }, onKeyDown: (e) => {
                if (e.key === "Enter")
                    e.currentTarget.blur();
                if (e.key === "Escape") {
                    onChange(originalRef.current);
                    setEditing(false);
                }
            } })) : (react_1.default.createElement("span", { className: "vacation-limit-value", title: "Kliknij, aby edytowa\u0107", onClick: () => {
                originalRef.current = value;
                setEditing(true);
            } }, value))));
}
/** Kolumna salda urlopu: Obecny/Zaległy (edytowalne) + Wyk./Poz. */
function VacationBalanceCell({ row, onLimitChange, onLimitSave }) {
    const balance = poolBalances(row).vacation;
    const save = () => saveAll(row, onLimitSave);
    return (react_1.default.createElement("div", { className: "vacation-balance-row" },
        react_1.default.createElement(LimitInput, { label: "Obecny", title: "urlop za bie\u017C\u0105cy rok", value: row.limitDays, onChange: (v) => onLimitChange(row.personId, "limitDays", v), onBlur: save }),
        react_1.default.createElement(LimitInput, { label: "Zaleg\u0142y", title: "urlop zaleg\u0142y z poprzedniego roku", value: row.carryoverDays, onChange: (v) => onLimitChange(row.personId, "carryoverDays", v), onBlur: save }),
        react_1.default.createElement(RemainingValue, { balance: balance },
            (0, vacationViewUtils_1.formatDays)(row.usedDays),
            " / ",
            (0, vacationViewUtils_1.formatDays)(balance.remaining))));
}
/** Kolumna salda opieki: pula (edytowalna) + Wyk./Poz. */
function CareBalanceCell({ row, onLimitChange, onLimitSave }) {
    const balance = poolBalances(row).care;
    const save = () => saveAll(row, onLimitSave);
    return (react_1.default.createElement("div", { className: "vacation-balance-row" },
        react_1.default.createElement(LimitInput, { label: "Pula", title: "pula dni opieki na dany rok", value: row.careDays, onChange: (v) => onLimitChange(row.personId, "careDays", v), onBlur: save }),
        react_1.default.createElement(RemainingValue, { balance: balance },
            (0, vacationViewUtils_1.formatDays)(row.careUsedDays),
            " / ",
            (0, vacationViewUtils_1.formatDays)(balance.remaining))));
}
/**
 * Kolumna salda wolnego za święta: pula (edytowalna) + Wyk./Poz.
 * Pula to liczba świąt, które w danym roku wypadły w sobotę (art. 130 §2 KP) —
 * wpisywana ręcznie, bo system nie zna kalendarza świąt.
 */
function HolidayBalanceCell({ row, onLimitChange, onLimitSave }) {
    const balance = poolBalances(row).holiday;
    const save = () => saveAll(row, onLimitSave);
    return (react_1.default.createElement("div", { className: "vacation-balance-row" },
        react_1.default.createElement(LimitInput, { label: "Pula", title: "dni wolne za \u015Bwi\u0119ta wypadaj\u0105ce w sobot\u0119, na dany rok", value: row.holidayDays, onChange: (v) => onLimitChange(row.personId, "holidayDays", v), onBlur: save }),
        react_1.default.createElement(RemainingValue, { balance: balance },
            (0, vacationViewUtils_1.formatDays)(row.holidayUsedDays),
            " / ",
            (0, vacationViewUtils_1.formatDays)(balance.remaining))));
}
const COLLAPSE_HINT = "Kliknij, aby zwinąć salda.";
/**
 * Nagłówki kolumn sald. Sam nagłówek jest przełącznikiem — klik w dowolny z nich
 * zwija panel, klik w zwinięty rozwija go z powrotem. Strzałka siedzi w ostatniej
 * kolumnie, więc po rozwinięciu jest na prawym końcu bloku sald.
 */
function BalanceHeaders({ show, onToggle, }) {
    const toggle = {
        className: "vacation-balance-col vacation-balance-head",
        onClick: onToggle,
        role: "button",
        "aria-expanded": show,
    };
    if (!show)
        return (react_1.default.createElement("th", { ...toggle, title: "Pozosta\u0142o dni w ka\u017Cdej puli. Kliknij, aby rozwin\u0105\u0107 i edytowa\u0107 wymiary." },
            react_1.default.createElement("div", { className: "vacation-balance-head-row" },
                react_1.default.createElement("div", { className: "vacation-pool-grid vacation-pool-labels" }, POOLS.map((pool) => (react_1.default.createElement("span", { key: pool.key }, pool.short)))),
                react_1.default.createElement("span", { className: "vacation-chevron" }, "\u25B8"))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("th", { ...toggle, title: COLLAPSE_HINT },
            react_1.default.createElement("div", { className: "vacation-balance-head-row" }, "Urlop")),
        react_1.default.createElement("th", { ...toggle, title: COLLAPSE_HINT },
            react_1.default.createElement("div", { className: "vacation-balance-head-row" }, "Opieka")),
        react_1.default.createElement("th", { ...toggle, title: `Wolne za święta wypadające w sobotę. ${COLLAPSE_HINT}` },
            react_1.default.createElement("div", { className: "vacation-balance-head-row" },
                "Za \u015Bwi\u0119ta",
                react_1.default.createElement("span", { className: "vacation-chevron" }, "\u25C2")))));
}
/**
 * Komórki sald jednego wiersza. Zwinięte: trzy liczby "ile pozostało", ustawione
 * w tej samej siatce co etykiety w nagłówku. Rozwinięte: pełne kolumny z edycją pul.
 */
function BalanceCells({ show, row, onLimitChange, onLimitSave, }) {
    if (!show) {
        const balances = poolBalances(row);
        return (react_1.default.createElement("td", { className: "vacation-balance-col" },
            react_1.default.createElement("div", { className: "vacation-pool-grid" }, POOLS.map((pool) => (react_1.default.createElement(RemainingValue, { key: pool.key, balance: balances[pool.key] }))))));
    }
    const cellProps = { row, onLimitChange, onLimitSave };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("td", { className: "vacation-balance-col" },
            react_1.default.createElement(VacationBalanceCell, { ...cellProps })),
        react_1.default.createElement("td", { className: "vacation-balance-col" },
            react_1.default.createElement(CareBalanceCell, { ...cellProps })),
        react_1.default.createElement("td", { className: "vacation-balance-col" },
            react_1.default.createElement(HolidayBalanceCell, { ...cellProps }))));
}
/** Widok roczny: proporcjonalny timeline urlopów per osoba. */
function YearView({ data, showBalances, onToggleBalances, onOpenEdit, onLimitChange, onLimitSave, }) {
    const ticks = (0, vacationViewUtils_1.monthTicks)(data.year);
    const todayPct = (0, vacationViewUtils_1.todayMarkerPct)(data.year);
    return (react_1.default.createElement("div", { className: "vacations-scroll" },
        react_1.default.createElement(react_bootstrap_1.Table, { bordered: true, hover: true, size: "sm", className: "vacation-year" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { className: "vacation-name-col" }, "Osoba"),
                    react_1.default.createElement(BalanceHeaders, { show: showBalances, onToggle: onToggleBalances }),
                    react_1.default.createElement("th", null,
                        react_1.default.createElement("div", { className: "vacation-track vacation-track-header" }, ticks.map((t) => (react_1.default.createElement("span", { key: t.label, className: "vacation-tick", style: { left: `${t.leftPct}%` } }, t.label))))))),
            react_1.default.createElement("tbody", null, data.rows.map((row) => (react_1.default.createElement("tr", { key: row.personId },
                react_1.default.createElement("td", { className: "vacation-name-col" }, row.personName),
                react_1.default.createElement(BalanceCells, { show: showBalances, row: row, onLimitChange: onLimitChange, onLimitSave: onLimitSave }),
                react_1.default.createElement("td", { className: "vacation-timeline-cell" },
                    react_1.default.createElement("div", { className: "vacation-track" },
                        todayPct !== null && (react_1.default.createElement("span", { className: "vacation-today-line", style: { left: `${todayPct}%` } })),
                        ticks.map((t) => (react_1.default.createElement("span", { key: t.label, className: "vacation-gridline", style: { left: `${t.leftPct}%` } }))),
                        row.absences.map((a) => {
                            const style = (0, vacationViewUtils_1.yearBarStyle)(a, data.year);
                            if (!style)
                                return null;
                            return (react_1.default.createElement("div", { key: a.id, className: "vacation-bar" +
                                    ((0, vacationViewUtils_1.isPartialDay)(a) ? " vacation-partial" : ""), style: {
                                    left: `${style.leftPct}%`,
                                    width: `${style.widthPct}%`,
                                    // celowo backgroundColor, nie background:
                                    // skrót skasowałby background-image z arkusza,
                                    // czyli prążki dnia częściowego
                                    backgroundColor: a._typeColor,
                                }, title: (0, vacationViewUtils_1.absenceTooltip)(a, true), onClick: () => onOpenEdit(row, a.dateFrom) }));
                        }))))))))));
}
/** Widok miesięczny: siatka dni (weekendy wyszarzone), kolor = typ urlopu. */
function MonthView({ data, year, month0, showBalances, onToggleBalances, onOpenEdit, onLimitChange, onLimitSave, }) {
    const dayCount = (0, vacationViewUtils_1.daysInMonth)(year, month0);
    const days = Array.from({ length: dayCount }, (_, i) => i + 1);
    const today = (0, vacationViewUtils_1.todayYmd)();
    return (react_1.default.createElement("div", { className: "vacations-scroll" },
        react_1.default.createElement(react_bootstrap_1.Table, { bordered: true, size: "sm", className: "vacation-month" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { className: "vacation-name-col" }, "Osoba"),
                    react_1.default.createElement(BalanceHeaders, { show: showBalances, onToggle: onToggleBalances }),
                    days.map((d) => {
                        const dateStr = (0, vacationViewUtils_1.ymd)(year, month0, d);
                        return (react_1.default.createElement("th", { key: d, className: "vacation-day-head" +
                                ((0, vacationViewUtils_1.isWeekendYmd)(dateStr) ? " vacation-weekend" : "") +
                                (dateStr === today ? " vacation-today" : "") }, d));
                    }))),
            react_1.default.createElement("tbody", null, data.rows.map((row) => (react_1.default.createElement("tr", { key: row.personId },
                react_1.default.createElement("td", { className: "vacation-name-col" }, row.personName),
                react_1.default.createElement(BalanceCells, { show: showBalances, row: row, onLimitChange: onLimitChange, onLimitSave: onLimitSave }),
                days.map((d) => {
                    const dateStr = (0, vacationViewUtils_1.ymd)(year, month0, d);
                    const weekend = (0, vacationViewUtils_1.isWeekendYmd)(dateStr);
                    const absence = (0, vacationViewUtils_1.findAbsenceOn)(row.absences, dateStr);
                    // weekend zawsze szary — urlop w weekend nie liczy się do wykorzystanych
                    const showColor = absence && !weekend;
                    return (react_1.default.createElement("td", { key: d, className: "vacation-day-cell" +
                            (weekend ? " vacation-weekend" : "") +
                            (showColor && (0, vacationViewUtils_1.isPartialDay)(absence)
                                ? " vacation-partial"
                                : "") +
                            (dateStr === today ? " vacation-today" : ""), style: showColor
                            ? // backgroundColor, nie background - patrz wyżej
                                { backgroundColor: absence._typeColor }
                            : undefined, title: absence ? (0, vacationViewUtils_1.absenceTooltip)(absence) : undefined, onClick: () => onOpenEdit(row, dateStr) }));
                }))))))));
}
